!(function (e) {
  'function' == typeof define && define.amd ? define('beforeAfterProduct', e) : e()
})(function () {
  'use strict'
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.selectors = {
          slider: '.js-ba-compare-slider',
          range: '.js-ba-input-range',
          overlayImage: '.js-ba-overlay-img',
          handle: '.js-ba-compare-handle',
          mSlider: '[data-slider-direction="vertical"]',
          dSlider: '[data-slider-direction="horizontal"]',
        }),
        (this.classes = { handle: 'js-ba-compare-handle' }),
        ((this.container = this).clicked = 0),
        (this.dSlider = this.container.querySelector(this.selectors.dSlider)),
        (this.dRange = this.dSlider.querySelector(this.selectors.range)),
        (this.dHandle = this.dSlider.querySelector(this.selectors.handle)),
        (this.dOverlayImage = this.dSlider.querySelector(this.selectors.overlayImage)),
        (this.mSlider = this.container.querySelector(this.selectors.mSlider)),
        (this.mRange = this.mSlider.querySelector(this.selectors.range)),
        (this.mHandle = this.mSlider.querySelector(this.selectors.handle)),
        (this.mOverlayImage = this.mSlider.querySelector(this.selectors.overlayImage))
    }
    connectedCallback() {
      this.container.addEventListener('mousedown', this._slideReady.bind(this)),
        window.addEventListener('mouseup', this._slideFinish.bind(this)),
        this.container.addEventListener('touchstart', this._slideReady.bind(this)),
        window.addEventListener('touchend', this._slideFinish.bind(this)),
        window.addEventListener('keyup', this._keyboardTabPress.bind(this))
    }
    _keyboardTabPress(e) {
      document.activeElement.closest(this.selectors.slider) && this._isArrowPressed(e)
    }
    _isArrowPressed(e) {
      var t,
        i = e.target,
        s = i.querySelector(this.selectors.range),
        r = i.querySelector(this.selectors.overlayImage),
        l = i.querySelector(this.selectors.handle)
      let d = parseInt(s.value),
        o = (d / 100) * i.offsetWidth
      39 == e.keyCode &&
        ((d += 1),
        (t = ((i.offsetWidth - 25) / i.offsetWidth) * 100),
        (d = d >= t ? t : d),
        (s.value = d),
        (o = (o = (d / 100) * i.offsetWidth) >= i.offsetWidth - 24 ? i.offsetWidth - 24 : o),
        (r.style.width = o + 'px'),
        (l.style.left = o - 24 + 'px')),
        37 == e.keyCode &&
          ((d -= 1),
          (t = (25 / i.offsetWidth) * 100),
          (d = d <= t ? t : d),
          (s.value = d),
          (o = (o = (d / 100) * i.offsetWidth) <= 24 ? 24 : o),
          (r.style.width = o + 'px'),
          (l.style.left = o - 24 + 'px'))
    }
    _slideReady(e) {
      e.target.classList.contains(this.classes.handle) &&
        (e.preventDefault(),
        (this.clicked = 1),
        'horizontal' == (e = e.target.closest(this.selectors.slider).dataset.sliderDirection) &&
          (this.container.addEventListener('mousemove', this._sliderMoveHorizontal),
          this.container.addEventListener('touchmove', this._sliderMoveHorizontal)),
        'vertical' == e) &&
        (this.container.addEventListener('mousemove', this._sliderMoveVertical),
        this.container.addEventListener('touchmove', this._sliderMoveVertical))
    }
    _sliderMoveVertical(e) {
      if (0 == this.clicked) return !1
      var t = this.mSlider.offsetHeight
      let i = this._getVerticalCursorPosition(e)
      ;(i = i < 24 ? 24 : i) > t - 24 && (i = t - 24), this._slideVertical(i, t)
    }
    _getVerticalCursorPosition(e) {
      var t,
        i = 0
      return (
        (e = e.changedTouches ? e.changedTouches[0] : e),
        (t = this.mSlider.getBoundingClientRect()),
        (i = e.pageY - t.top),
        (i -= window.pageYOffset)
      )
    }
    _slideVertical(e, t) {
      ;(this.mRange.value = (e / t) * 100),
        (this.mOverlayImage.style.height = e + 'px'),
        (this.mHandle.style.top = e - 24 + 'px')
    }
    _sliderMoveHorizontal(e) {
      if (0 == this.clicked) return !1
      var t = this.dSlider.offsetWidth
      let i = this._getHorizontalCursorPosition(e)
      ;(i = i < 24 ? 24 : i) > t - 24 && (i = t - 24), this._slideHorizontal(i, t)
    }
    _getHorizontalCursorPosition(e) {
      var t,
        i = 0
      return (
        (e = e.changedTouches ? e.changedTouches[0] : e),
        (t = this.dSlider.getBoundingClientRect()),
        (i = e.pageX - t.left),
        (i -= window.pageXOffset)
      )
    }
    _slideHorizontal(e, t) {
      ;(this.dRange.value = (e / t) * 100),
        (this.dOverlayImage.style.width = e + 'px'),
        (this.dHandle.style.left = e - 24 + 'px')
    }
    _slideFinish() {
      this.clicked = 0
    }
  }
  var t, i
  ;(t = 'before-after'), (i = e), void 0 === customElements.get(t) && customElements.define(t, i)
})
